module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/officer.png?a11c34f16c62245ed68bce5c69ecae4a";